const CONTRIBUTION_ID_PATTERN = /^[A-Za-z0-9_-]+$/;

export function parseCircuitRouteId(routeId: string | undefined): string | null {
  if (!routeId) {
    return null;
  }

  try {
    const decodedRouteId = decodeURIComponent(routeId);
    return CONTRIBUTION_ID_PATTERN.test(decodedRouteId) ? decodedRouteId : null;
  } catch {
    return null;
  }
}
